import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import DomainValue from './DomainValue';

/**
 * View of a single domainInvitation usage
 */

const styles = theme => ({
  captionColor: {
    color: '#A1A1A1'
  }
});

const DomainUsage = ({subscription, classes}) => {
  return (
          <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}} >
            <Typography align="center" variant="caption" className={classes.captionColor}>
              <FormattedMessage id="subscription.card.domainUsage.label" />
            </Typography>
          
            <Typography align="center">
              <DomainValue 
                subscription={subscription}
              />
            </Typography>
          
          </div>
  );
}

export default withStyles(styles) (DomainUsage);


// WEBPACK FOOTER //
// ./src/components/domains/DomainUsage.js